<pcg-resizable-widget (keydown)="peruseOrgs($event)">
    <span widget-title>ORGANIZATION SEARCH</span>
    <div class="org-actions" widget-subheader>
        <input 
            #searchStr
            class="w-100" 
            type="text" 
            placeholder="Enter Name, Phone #, or Address"
            (keydown.enter)="pressEnter(searchStr.value)"
            (keyup)="filterOrgs(searchStr.value)"
        />  
    </div>
    <div class="h-100 widget-body" widget-body>
        @if (isLoading()) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Organizations...
            </div>
        } @else {
            @for (org of filteredOrgs(); track org) {
                <button 
                    [id]="'org' + $index"
                    class="org-item org-button" 
                    (click)="redirect(org)"
                >
                    <div style="display:flex; flex-direction:column; gap:3px; flex:1;">
                        <div style="display:flex; align-items:center; gap:10px;">
                            <span class="org-number">{{ org.name }}</span>
                        </div>
                        <span style="font-size:11px; color:#9aabba; font-family:'DM Mono',monospace;">{{ org.phoneNumber }} | {{org.address}}</span>
                    </div>
                </button>
            } @empty { 
                <div class="empty-row justify-content-center">
                    <span class="org-number">Start typing to find organizations!</span>
                </div> 
            }
        }
    </div>
</pcg-resizable-widget>